import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Confirm,
  Divider,
  Segment,
  Menu
} from "semantic-ui-react";
import ReactTable from "react-table";
import request from "../../utils/request";
import matchSorter from 'match-sorter';

class NonProfitList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      sort: [{ id: "id", desc: false }],
      data: [],
      query: "",
      limit: 20,
      page: 1,
      total: 0,
      confirm: {
        open: false,
        id: 0,
        content: ""
      },
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .get(this, "api:/non-profit", {
        sort: this.state.sort,
        q: this.state.query,
        page: this.state.page,
        limit: this.state.limit
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          total: Math.ceil(resp.total / this.state.limit)
        });
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };
  startDelete = (e) => {
    this.setState({
      confirm: {
        open: true,
        id: e.currentTarget.dataset.id,
        content: e.currentTarget.dataset.message
      }
    });
  }
  cancelDelete = () => {
    this.setState({
      confirm: {
        open: false,
        id: 0,
        content: ""
      }
    });
  }
  confirmDelete = () => {
    const { confirm } = this.state;
    return request.delete(this, `api:/non-profit/${confirm.id}`)
      .then(resp => {
        this.setState({
          confirm: {
            open: false,
            id: 0,
            content: ""
          }
        }, this.fetchData);
      });
  }
  render() {
    const {
      confirm,
      data,
      limit,
      isLoading
    } = this.state;
    const columns = [
      {
        accessor: d => (
          <div>
            <Button as={Link} to={`/non-profits/${d.id}/edit`} icon="edit" primary />
            <Button icon="trash" color="red" data-id={d.id} data-message={`Are you sure you want to delete ${d.name}?`} onClick={this.startDelete} />
          </div>
        ),
        id: "id",
        Header: "Action",
        filterable: false
      },
      {
        accessor: "name",
        Header: "Name",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["name"] }),
        filterAll: true
      },
      {
        accessor: "fed_tax_id",
        Header: "Tax ID #",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["fed_tax_id"] }),
        filterAll: true
      },
      {
        accessor: "address",
        Header: "Address",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["address"] }),
        filterAll: true
      },
      {
        accessor: "email",
        Header: "Email",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["email"] }),
        filterAll: true
      },
      {
        accessor: "phone_number",
        Header: "Telephone",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["phone_number"] }),
        filterAll: true
      }
    ];
    return (
      <Segment basic>
        <Confirm
          open={confirm.open}
          content={confirm.content}
          cancelButton={confirm.id > 0 ? "Cancel" : "Close"}
          confirmButton={confirm.id > 0 ? "Confirm" : false}
          onCancel={this.cancelDelete}
          onConfirm={this.confirmDelete}
        />
        <Menu secondary stackable>         
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                as={Link}
                to={"/non-profits/create"}
                icon="line graph"
                content="New Non-profit"
                primary
                fluid
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"                    
          loading={isLoading} // Display the loading overlay when we need it          
          filterable          
          defaultPageSize={limit}
          minRows={0}
        />
      </Segment>
    );
  }
}

export default NonProfitList;
